export const formatAddressFromJawgs = (feature) => {
    return {
        label: feature.properties.label,
        name: feature.properties.name,
        postcode: feature.properties.postalcode,
        state: feature.properties.macroregion,
        city: feature.properties.locality,
        country: feature.properties.country,
        countryCode: feature.properties.country_code,
        latlng: {
            lng: feature.geometry.coordinates[0],
            lat: feature.geometry.coordinates[1],
        },
    }
}